import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import SwipeableViews from "react-swipeable-views"; // Material imports

import { withStyles } from "@material-ui/core/styles"; // Limitless imports

import TestimonialScreen from "./TestimonialScreen";
import CSATScreen from "./CSATScreen";

var calculateStartStep = function calculateStartStep(message) {
  var step = 0;

  if (message.custResolved && message.customerScore) {
    step = 1;
  }
  /** v3 golden rule, cannot rate if the message is closed */


  if (message.state === "closed") {
    step = 1;
  }

  return step;
};

var RateFinishMessageFooter = function RateFinishMessageFooter(_ref) {
  var classes = _ref.classes,
      onCancelDialog = _ref.onCancelDialog,
      message = _ref.message,
      onSubmitCSATScore = _ref.onSubmitCSATScore,
      rest = _objectWithoutProperties(_ref, ["classes", "onCancelDialog", "message", "onSubmitCSATScore"]);

  //if the message has a score but doesn't have a testimonial, send them straight to the testimonial
  var _React$useState = React.useState(calculateStartStep(message)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      step = _React$useState2[0],
      setStep = _React$useState2[1];

  React.useEffect(function () {
    /** v3 golden rule, cannot rate if the message is closed */
    if (message.state === "closed") {
      setStep(1);
    }
  }, [message.state]);

  var updateStepHandle = function updateStepHandle(score) {
    onSubmitCSATScore(score, function () {
      setStep(1);
    });
  };

  return /*#__PURE__*/React.createElement(SwipeableViews, {
    index: step,
    onChangeIndex: setStep,
    className: classes.swipeableViewContainer,
    containerStyle: {
      height: "unset",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(CSATScreen, Object.assign({}, rest, {
    message: message,
    containerClass: classes.container,
    onSubmitCSATScore: updateStepHandle
  })), /*#__PURE__*/React.createElement(TestimonialScreen, Object.assign({}, rest, {
    containerClass: classes.container,
    message: message,
    onCancelDialog: onCancelDialog
  })));
};

var styles = function styles() {
  return {
    swipeableViewContainer: {
      height: "100%",
      width: 300
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: 300,
      minHeight: 220
    }
  };
};

export default withStyles(styles)(RateFinishMessageFooter);